











import { defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'BaseBadge',
  data(...args): any {
    return args;
  },
});
